import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { clearAuthStorage, login as apiLogin } from '../utils/api';

export const useAuthStore = create(
  persist(
    (set, get) => ({
      user:  null,
      token: null,
      isAuthenticated: false,

      login: async (username, password) => {
        const { data } = await apiLogin({ username, password });
        localStorage.setItem('daima_token', data.token);
        set({ user: data.user, token: data.token, isAuthenticated: true });
        return data.user;
      },

      logout: () => {
        clearAuthStorage();
        set({ user: null, token: null, isAuthenticated: false });
      },

      isAdmin:      () => get().user?.role === 'admin',
      isSupervisor: () => ['admin','supervisor'].includes(get().user?.role),
    }),
    { name: 'daima_auth', partialize: (s) => ({ user: s.user, token: s.token, isAuthenticated: s.isAuthenticated }) }
  )
);

// Cart store (POS terminal state)
export const useCartStore = create((set, get) => ({
  items: [],
  discountPct: 0,
  paymentMethod: 'cash',
  mpesaRef: '',

  addItem: (product) => {
    const items = get().items;
    const existing = items.find(i => i.id === product.id);
    if (existing) {
      if (existing.qty >= product.stock) return false; // out of stock
      set({ items: items.map(i => i.id === product.id ? { ...i, qty: i.qty + 1 } : i) });
    } else {
      set({ items: [...items, { ...product, qty: 1 }] });
    }
    return true;
  },

  removeItem: (id) => set({ items: get().items.filter(i => i.id !== id) }),

  updateQty: (id, qty) => {
    if (qty <= 0) return set({ items: get().items.filter(i => i.id !== id) });
    set({ items: get().items.map(i => i.id === id ? { ...i, qty } : i) });
  },

  setDiscount: (pct) => set({ discountPct: Math.max(0, Math.min(100, pct)) }),
  setPaymentMethod: (m) => set({ paymentMethod: m }),
  setMpesaRef: (r) => set({ mpesaRef: r }),

  clear: () => set({ items: [], discountPct: 0, paymentMethod: 'cash', mpesaRef: '' }),

  totals: () => {
    const { items, discountPct } = get();
    const subtotal   = items.reduce((s, i) => s + i.price * i.qty, 0);
    const discountAmt = subtotal * (discountPct / 100);
    const afterDisc  = subtotal - discountAmt;
    const taxAmt     = afterDisc * 0.16;
    const total      = afterDisc + taxAmt;
    const itemCount  = items.reduce((s, i) => s + i.qty, 0);
    return { subtotal, discountAmt, afterDisc, taxAmt, total, itemCount };
  },
}));
